//! Import from chart.js/auto else you must
//! register all used components manually
import { Chart } from "chart.js/auto";
export default Chart;
